import { render, staticRenderFns } from "./BatchCategoryLotUp.vue?vue&type=template&id=246ef8f0&scoped=true"
import script from "./BatchCategoryLotUp.vue?vue&type=script&lang=js"
export * from "./BatchCategoryLotUp.vue?vue&type=script&lang=js"
import style0 from "./BatchCategoryLotUp.vue?vue&type=style&index=0&id=246ef8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ef8f0",
  null
  
)

export default component.exports